/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 言語コード
 * @export
 * @enum {number}
 */
export enum LanguageCodeEnum {
    /** 日本語 */
    JA = 'ja',
    /** 英語 */
    EN = 'en'
}

/**
 * 言語コード の Union 型
 * @export
 * @typedef LanguageCode
 */
export type LanguageCode =
  typeof LanguageCodeEnum[keyof typeof LanguageCodeEnum];

/**
 * 言語コード のラベルマップ
 * @export
 */
export const LanguageCodeLabels = {
    /**
     * 数値キー: LanguageCodeEnum.JA
     * 名前キー:  JA
     */
    [LanguageCodeEnum.JA]: '日本語',
    JA:                             '日本語',
    /**
     * 数値キー: LanguageCodeEnum.EN
     * 名前キー:  EN
     */
    [LanguageCodeEnum.EN]: '英語',
    EN:                             '英語',
} as const;

/**
 * 言語コード のラベル Union 型
 * @export
 * @typedef LanguageCodeLabel
 */
export type LanguageCodeLabel =
  typeof LanguageCodeLabels[keyof typeof LanguageCodeLabels];

/**
 * 言語コード のラベル取得関数
 * @export
 * @param { LanguageCode } value - 列挙体の値
 * @returns { LanguageCodeLabel } ラベル文字列
 */
export function getLanguageCodeLabel(
  value: LanguageCode
): LanguageCodeLabel {
  return LanguageCodeLabels[value];
}

/**
 * 言語コード のラベル配列を取得する関数
 * @export
 * @param { LanguageCode[] } values - 列挙体の値配列
 * @returns { LanguageCodeLabel[] } ラベル文字列配列
 */
export function getLanguageCodeLabels(values: LanguageCode[]): LanguageCodeLabel[] {
  return values.map((value) => getLanguageCodeLabel(value));
}

/**
 * 言語コード のラベル配列
 * @export
 */
export const LanguageCodeLabelList = [
  '日本語','英語',
] as const;

